import { render, staticRenderFns } from "./compclear.vue?vue&type=template&id=05b73823"
import script from "./compclear.vue?vue&type=script&lang=js"
export * from "./compclear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports